import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Card } from '../../../components/ui/card';
import { Button } from '../../../components/ui/button';
import { Download, Loader2, Upload, ArrowRight } from 'lucide-react';
import { adminAPI } from '../../../services/api';
import { toast } from '../../../hooks/use-toast';
import { ModuleShell } from './ModuleShell';

const EXPORTS = [
  { key: 'products', label: 'Productos' },
  { key: 'orders', label: 'Pedidos' },
  { key: 'users', label: 'Usuarios' },
];

export const ImportExportPage = () => {
  const [busy, setBusy] = useState(null);
  const download = async (entity) => {
    setBusy(entity);
    try {
      const blob = await adminAPI.exportCsv(entity);
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url; a.download = `zonalibre_${entity}.csv`; a.click();
      URL.revokeObjectURL(url);
    } catch {
      toast({ title: 'No se pudo exportar', variant: 'destructive' });
    } finally { setBusy(null); }
  };
  return (
    <ModuleShell title="Importar / Exportar" description="Descarga tus datos en CSV"
      note="La exportación a CSV ya funciona. La importación masiva todavía no está configurada." testid="module-import-export">
      <div className="grid sm:grid-cols-3 gap-4">
        {EXPORTS.map(e => (
          <Card key={e.key} className="bg-gray-800 border-gray-700 p-5">
            <p className="text-white font-semibold">{e.label}</p>
            <p className="text-xs text-gray-500 mb-4">Archivo CSV</p>
            <Button onClick={() => download(e.key)} disabled={busy === e.key} variant="outline" className="w-full border-gray-600 text-gray-200" data-testid={`export-${e.key}-btn`}>
              {busy === e.key ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <Download className="w-4 h-4 mr-2" />} Exportar
            </Button>
          </Card>
        ))}
      </div>
      <Card className="bg-gray-800/50 border-dashed border-gray-700 p-6 text-center">
        <Upload className="w-8 h-8 text-gray-600 mx-auto mb-2" />
        <p className="text-gray-400 text-sm">Importación masiva desde CSV · Próximamente</p>
      </Card>
    </ModuleShell>
  );
};

const REQUESTS = [
  { key: 'payment_approvals', label: 'Pagos por transferencia por aprobar', to: '/admin/orders' },
  { key: 'withdrawals', label: 'Retiros de saldo pendientes', to: '/admin/bank' },
  { key: 'frozen_escrow', label: 'Fondos congelados por resolver', to: '/admin/bank' },
  { key: 'drivers', label: 'Repartidores por verificar', to: '/admin/delivery-drivers' },
  { key: 'questions', label: 'Preguntas sin responder', to: '/admin/products' },
];

export const RequestsPage = () => {
  const [summary, setSummary] = useState(null);
  useEffect(() => { adminAPI.getRequestsSummary().then(setSummary).catch(() => setSummary({})); }, []);
  return (
    <ModuleShell title="Solicitudes" description="Bandeja de todo lo que espera una acción del equipo"
      note="Vista básica que reúne pendientes de otras secciones. Aún no hay flujo propio de aprobación aquí." testid="module-requests">
      <Card className="bg-gray-800 border-gray-700 divide-y divide-gray-700">
        {!summary ? <div className="p-6"><Loader2 className="w-5 h-5 animate-spin text-gray-400" /></div> : REQUESTS.map(r => (
          <Link key={r.key} to={r.to} className="flex items-center gap-4 p-4 hover:bg-gray-700/40 transition-colors" data-testid={`request-${r.key}`}>
            <span className={`w-10 text-center text-lg font-bold tabular-nums ${summary[r.key] ? 'text-orange-400' : 'text-gray-600'}`}>{summary[r.key] ?? 0}</span>
            <span className="flex-1 text-gray-200 text-sm">{r.label}</span>
            <ArrowRight className="w-4 h-4 text-gray-500" />
          </Link>
        ))}
      </Card>
    </ModuleShell>
  );
};
